import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { doctrineAnalytics } from '../../utils/analyticsUtils';
import styles from './nav_demo.module.scss';
import { NavItemLink } from '../../navigation/components/item/NavItem';

export const NavDemo: FC = () => {
  const askDemo = () => {
    doctrineAnalytics('AskDemoClicked', { source: 'header' });
  };

  return (
    <NavItemLink
      href="/demo"
      source="header"
      target="_blank"
      className={styles.puslsating}
      onClick={askDemo}
    >
      <span className={styles.circle} />
      <span className={styles.smallCircle} />
      <span className={styles.text}>
        <FormattedMessage id="demo/nav/NavDemo.tsx/1" />
      </span>
    </NavItemLink>
  );
};
